import styled from "styled-components"
import { motion } from "framer-motion"

export const NavTabs = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 80px;

  @media (max-width: 768px) {
    margin-top: 60px;
    flex-direction: column;
    gap: 8px;
  }
`

export const NavTab = styled(motion.button)<{ isActive: boolean }>`
  background: ${(props) => (props.isActive ? "#4A88F3" : "rgba(255, 255, 255, 0.1)")};
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: ${(props) => (props.isActive ? "#3B78E0" : "rgba(255, 255, 255, 0.15)")};
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`

export const TabContent = styled(motion.div)`
  width: 100%;
`

